import { render, staticRenderFns } from "./Luoxuan.vue?vue&type=template&id=82cf597e&"
import script from "./Luoxuan.vue?vue&type=script&lang=js&"
export * from "./Luoxuan.vue?vue&type=script&lang=js&"
import style0 from "./Luoxuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports